export type ValidLocale = 'de' | 'en' | 'fr' | 'it' | 'es';

export const currentLocaleStorageKey = 'currentLocale';

export function getAvailableLanguages(): ValidLocale[] {
    return ['de', 'en', 'fr', 'it', 'es'];
}

export function isValidLocale(locale: string): locale is ValidLocale {
    return (getAvailableLanguages() as string[]).includes(locale);
}

export function getLocale(storageLocale: string | null): ValidLocale {
    if (storageLocale && isValidLocale(storageLocale)) {
        return storageLocale;
    }

    const preferredLocale = navigator.language.substr(0, 2).toLowerCase();

    if (isValidLocale(preferredLocale)) {
        return preferredLocale;
    }

    return 'en';
}

/**
 * Gets the current valid locale from either local storage or the preferred user language.
 *
 * This method should only be used outside any Vue context.
 * Within a Vue context, `useLocaleStore` should be used.
 */
export function getCurrentLocale(): ValidLocale {
    const storageLocale = localStorage.getItem(currentLocaleStorageKey);
    return getLocale(storageLocale);
}
